import { createAsyncThunk } from '@reduxjs/toolkit';
import { getOneClickEuvMethodsByContactId, getOneClickEuvMethodsByTicketId } from 'services/pod';
import { IOneClickEuvMethod } from 'services/pod/types';
import { RootState } from 'store/index';
import { getRequestKey } from 'store/oneClickEuvMethods/helpers';

interface IProps {
  psaId: number;
  ticketId?: string;
  contactId?: string;
}

export const ThunkGetOneClickEuvMethods = createAsyncThunk<IOneClickEuvMethod[], IProps>(
  'oneClickEuvMethods/getOneClickEuvMethods',
  async ({ psaId, ticketId, contactId }) =>
    contactId
      ? getOneClickEuvMethodsByContactId(psaId, contactId).then(r => r.data)
      : getOneClickEuvMethodsByTicketId(psaId, String(ticketId)).then(r => r.data),
  {
    condition: (arg, { getState }) =>
      getRequestKey(arg) !== (getState() as RootState).oneClickEuvMethods.requestedKey,
  },
);
